import { DropdownPopoverProps } from 'modules/common/components/ToolbarPopover/DropdownPopover';
import { WidgetType } from 'types/widget.types';

export const DEFAULT_SEPARATOR = 'None';
export const separatorConfig = [
  {
    label: ',(comma)',
    value: ',',
  },
  {
    label: ';(semicolon)',
    value: ';',
  },
  {
    label: '(space)',
    value: ' ',
  },
  {
    label: 'None',
    value: 'None',
  },
];

export const DEFAULT_DECIMAL = 'Auto';
export const decimalConfig = [
  {
    label: 'Auto',
    value: 'Auto',
  },
  {
    label: '0',
    value: '0',
  },
  {
    label: '1',
    value: '1',
  },
  {
    label: '2',
    value: '2',
  },
  {
    label: '3',
    value: '3',
  },
  {
    label: '4',
    value: '4',
  },
];

export const HAS_PERCENTAGE = [
  WidgetType.PieChart,
  WidgetType.HalfPieChart,
  WidgetType.StackedBarChart,
  WidgetType.StackedColumnChart,
  WidgetType.PyramidChart,
  WidgetType.FunnelChart,
  WidgetType.AreaSplineChart,
  WidgetType.AreaChart,
  WidgetType.StackedAreaChart,
  WidgetType.StackedBarChart,
  WidgetType.ScatterBubbleChart,
  WidgetType.ColumnChart,
  WidgetType.BarChart,
  WidgetType.LineChart,
  WidgetType.SplineChart,
];

/**
 * The styling properties of the trigger button that used in the number format dropdown
 */
export const TRIGGER_STYLE: DropdownPopoverProps['triggerProps'] = {
  height: 7,
  marginY: '6px',
  fontSize: 'sm',
  fontWeight: 'normal',
  sx: {
    '& > p': {
      fontSize: 'sm',
      fontWeight: 'normal',
    },
  },
};

/**
 * The styling properties of the button option that used in the number format dropdown
 */
export const BUTTON_OPTION_STYLE: DropdownPopoverProps['buttonOptionProps'] = {
  height: 7,
  lineHeight: 5,
  fontWeight: 'normal',
};
